module.exports = __webpack_public_path__ + "img/宋加峰.6d43867f.jpg";